import { RefObject, useLayoutEffect, useState } from "react";

/** How many result tiles fit in one row for the measured container width. */
export function useResultsColumns(
  ref: RefObject<HTMLElement>,
  minTileWidth: number,
  gap: number,
) {
  const [columns, setColumns] = useState(4);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;

    const measure = () => {
      const width = el.clientWidth;
      if (width <= 0) return;
      const cols = Math.max(1, Math.floor((width + gap) / (minTileWidth + gap)));
      setColumns(cols);
    };

    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(el);
    return () => ro.disconnect();
  }, [ref, minTileWidth, gap]);

  return columns;
}
